import validate from '@/utils/validations/minMaxWithoutMask'

export default {
    validate,
    message: (field, args) => {

        if (args[1] === undefined || args[0] === args[1])
            return `O campo ${field} deve conter ${args[0]} caracteres`

        return `${field} deve conter entre ${args[0]} e ${args[1]} caracteres`
    }
}